import React from 'react'
import Header from '../../../Components/Header'

function WhollyWithin({ heading_size = 2 }) {
    return (
        <>
            <Header text={"Wholly Within vs Within"} level={heading_size} />
            <div>
                Data
            </div>
        </>
    )
}

export default WhollyWithin